import { createAsyncThunk, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit'
import { Auth, } from 'aws-amplify';
import { RootState } from '../../store/store';
import { feedback } from '../../components/Feedback/feedback';
import { userUnauthenticated } from '../../App/app';

export type Loading = 'idle' | 'pending' | 'succeeded' | 'failed';


export interface LogoutState {
  loading: Loading;
  currentRequestId: string,
  error: SerializedError | null,
}

const initialState: LogoutState = {
  loading: 'idle',
  currentRequestId: '',
  error: null,
}

export const signOut = createAsyncThunk(
  'signOut',
  async ( _, thunkAPI ) => {
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.logout;

    if (loading !== 'pending' || thunkAPI.requestId !== currentRequestId) return false;

    return Auth.signOut( { global: false } ).then( cognitoUser => {

      return true;

    }).catch( error => {
      thunkAPI.dispatch( userUnauthenticated() )
      thunkAPI.dispatch( feedback( { message: error.message, severity: 'error' } ))
      return false;
    })
  }
)


export const logoutSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
  },
  extraReducers: ( builder ) => {
      builder
      .addCase( signOut.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending'
          state.currentRequestId = action.meta.requestId
        }
      })
      .addCase( signOut.fulfilled, (state, action) => {

        const { requestId } = action.meta

        if ( state.loading === 'pending' && state.currentRequestId === requestId) {

          state.currentRequestId = ''

          state.loading = 'idle';
        }
      })
      .addCase( signOut.rejected, ( state, action, ) => {
        const { requestId } = action.meta
        if ( state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle'
          state.error = action.error
          state.currentRequestId = ''
        }
      })

  },
})

export const {
} = logoutSlice.actions

export default logoutSlice.reducer;
